<template>
  <section id="testimonials" class="bg-secondary">
    <section-container>
      <div
        class="flex flex-row justify-center gap-10 text-lg px-2 py-8 md:p-10"
      >
        <div class="md:w-1/3" :class="{'hidden md:block': index === 1}" v-for="(testimonial, index) in testimonials" :key="testimonial.id">
          <img
            class="object-cover h-[310px] w-[530px] rounded-xl"
            :src="testimonial.image"
          />
          <figure>
            <blockquote class="text-white mt-4">
              <p>
                {{  testimonial.quote }}
              </p>
            </blockquote>
            <figcaption class="mt-4 text-white">
              <div class="font-semibold">{{  testimonial.name }}</div>
              <div class="font-light text-white/70">{{  testimonial.job }}</div>
            </figcaption>
          </figure>
        </div>

      </div>
    </section-container>
  </section>
</template>

<script setup>
defineProps({
  testimonials: {
    type: Array,
    default: () => [],
  },
})
</script>
